import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"


import moment from "moment"
import IndexBloc from "./Blocs/IndexBlock"

import CustomSelect from "../../GlobalComponents/CustomSelect"

import TableActiveComponent from './Components/TableActiveComponent'

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;  
    while ( startYear <= currentYear ) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }   
    return years;
}
  
const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function(month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}

const IndexView = (props) => {
  

    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();

    // Select
    const [yearOptions, setYearOptions] = useState(createYearOption(new Date().getFullYear() - 30));
    const [monthOptions, setMonthOptions] = useState(createMonthOptions());
    
    // Filter
    const [nip, setNip] = useState('')
    const [name, setName] = useState('')
    const [year, setYear] = useState(new Date().getFullYear())
    const [month, setMonth] = useState(moment().format('M'))

    let additionalFilter = {
        nip: nip,
        name: name,
        year: year,
        month: month
    };

    const reloadActiveRef = () => activeRef.current.setTokenAPI()

    function handleButtonSearch() {
      reloadActiveRef()
    }
    const exportExcel = () => activeRef.current.exportExcel()

    function handleButtonExport() {
        exportExcel()
    }
    function handleButtonReset() {
      setNip('');
      setName('');
      reloadActiveRef()
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                {/* {
                                    (accessRole('create')) ?
                                        <Link to="home.html?create">
                                            <Button color="primary">New Sample</Button>
                                        </Link>
                                    : null
                                } */}
                                </div>
                                <CardTitle>List Data Pegawai</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Seluruh Pegawai
                                </CardSubtitle>
                                <hr />

                                <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    NIP
                                    </label>
                                    <Col md="4">
                                        <Input
                                            type="text"
                                            name="nip"
                                            value={nip}
                                            onChange={event => setNip(event.target.value)}
                                        >
                                    </Input>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    Nama
                                    </label>
                                    <Col md="4">
                                        <Input
                                            type="text"
                                            name="name"
                                            value={name}
                                            onChange={event => setName(event.target.value)}
                                        >
                                    </Input>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="no_skx"
                                        className="col-md-2 col-form-label"
                                    >
                                    Bulan <span className="text-danger">*</span>
                                    </label>
                                    <Col md="2">
                                        <CustomSelect 
                                            name="period_month"
                                            errorMessage="Pilih Bulan"
                                            options={monthOptions} 
                                            placeholder="Pilih Bulan"
                                            defaultValue={month}
                                            onChange={(v) => setMonth(v.value)}
                                            isAvForm={false}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="no_skx"
                                        className="col-md-2 col-form-label"
                                    >
                                    Tahun <span className="text-danger">*</span>
                                    </label>
                                    <Col md="2">
                                        <CustomSelect 
                                            name="period_year"
                                            errorMessage="Pilih Tahun"
                                            options={yearOptions} 
                                            placeholder="Pilih Tahun"
                                            defaultValue={year}
                                            onChange={(v) => setYear(v.value)}
                                            isAvForm={false}
                                        />
                                    </Col>
                                </Row>
                               
                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        <Button
                                            color="success"
                                            type="button"
                                            onClick={() => {
                                                handleButtonExport()
                                            }}
                                        >
                                            Export Potongan Presensi
                                        </Button>
                                        {/* <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button> */}
                                    </Col>
                                </Row>

                                <hr />
                                
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                            </CardBody>
                        </Card>
                        
                       
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView